import styled from "styled-components";
import { useGetQueuedCommunicationsQuery } from "../../../data/generated";
import { theme } from "../../../theme";
import { QueuedCommunicationDetailsRow } from "./QueuedCommunicationDetailsRow";
import { Loader } from "../../../design-system/atoms/Loader";
import { Title } from "../../../design-system/atoms/Title";

export const QueuedCommunicationsList = ({
  filters,
}: {
  filters: {
    moduleSerialNumber: string;
  };
}) => {
  const { data, loading, error, fetchMore } = useGetQueuedCommunicationsQuery({
    variables: { limit: 50, offset: 0, filters },
    fetchPolicy: "cache-and-network",
  });

  if (error) {
    return null;
  }

  if (loading || !data) {
    return <Loader />;
  }

  const {
    queuedCommunications: { queuedCommunications, hasMore },
  } = data;

  function handleScroll({ currentTarget }: React.UIEvent<HTMLDivElement>) {
    if (
      currentTarget.scrollTop + currentTarget.clientHeight >=
      currentTarget.scrollHeight
    ) {
      if (hasMore) {
        fetchMore({
          variables: {
            offset: queuedCommunications.length,
            limit: 50,
            filters,
          },
        });
      }
    }
  }

  return (
    <Container>
      <Header>
        <Title>Queued communications</Title>
      </Header>
      <TableContainer>
        <Table onScroll={handleScroll}>
          <thead>
            <Tr>
              <Th>Module serial number</Th>
              <Th>Ordered at</Th>
              <Th>Command</Th>
              <Th>Data</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {queuedCommunications.map((queuedCommunication) => (
              <QueuedCommunicationDetailsRow
                key={queuedCommunication._id}
                queuedCommunication={queuedCommunication}
              />
            ))}
          </tbody>
        </Table>
        {queuedCommunications.length === 0 ? (
          <NoResultContainer>
            <p>No logs found</p>
          </NoResultContainer>
        ) : null}
      </TableContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid ${theme.borderColor.highlight};
  border-radius: 10px;
  overflow: hidden;
`;

const Header = styled.div`
  padding: 15px;
`;

const TableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const Table = styled.table`
  width: 100%;
`;

const Tr = styled.tr`
  background-color: ${theme.backgroundColor};
`;

const Th = styled.td<{ $isCentered?: boolean }>`
  position: sticky;
  top: 0px;
  background-color: ${theme.backgroundColor};
  font-weight: bold;
  text-align: ${({ $isCentered }) => ($isCentered ? "center" : "left")};
  padding: 5px;
  z-index: 1;
`;

const NoResultContainer = styled.div`
  display: flex;
  justify-content: center;
  color: ${theme.textColor.secondary};
`;
